<template>
  <div class="skeleton" :style="getStyle" v-bind:class="{ 'animatied-skeleton': animation && !skeletonItem.subChild, 'top-level' : toplevel }">
    <skeleton v-for="(item, index) in skeletonItem.subChild" :key="index" :skeletonItem="item" :toplevel="false" :animation="animation"/>
  </div>
</template>

<script>
export default {
  name: "skeleton",
  props:{
    skeletonItem:{
      type: Object,
      default: {}
    },
    animation:{
      type: Boolean,
      default: false,
    },
    toplevel: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    getStyle(){
      const { type = 'row', subChild, ...rest } = this.skeletonItem;

      return {
        display: 'flex',
        flexDirection: type,
        justifyContent: 'space-between',
        alignItems: 'center',
        ...rest
      }

    }
  }
}
// DEMO
// 在页面中引入组件
// <template v-if="true">
//   <Skeleton v-for="(item, index) in skeletonJson" :key="index" :skeletonItem="item" />
// </template>

// export const skeletonJson = [{
//   height: '100vw',
//   width: '100vw',
//   margin: 0
// },{
//     height: '34px',
//     marginTop: '25px',
//     marginBottom: '10px',
// },{
//     height: '30px',
//     marginBottom: '10px',
//     width: '102px',
// },
// {
//     marginTop: '10px',
//     marginBottom: '25px',
//     justifyContent:'flex-start',
//     marginLeft: '25px',
//     marginRight: '25px',
//     subChild:[{
//         height:'27px',
//         width:'50px',
//         marginLeft: 0,
//         marginRight: '10px',
//     },{
//         height:'27px',
//         width:'60px',
//         marginLeft: 0,
//         marginRight: '10px',
//     }]
// },{
//     height: '1px',
//     marginTop: '20px',
// }]
</script>

<style scoped lang="scss">
.skeleton{
  background: #F2F2F2;
  /* background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%); */
  background-size: 800px 104px;
  width: calc(100% - 50px);
  position: relative;

  &.top-level {
    margin: 0px 25px;
  }
}
.animatied-skeleton {
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  /* background: linear-gradient(to right, #eeeeee 5%, #dddddd 18%, #eeeeee 33%); */
  background: linear-gradient(to right, #f6f7f8 8%, #eeeeee 18%, #f6f7f8 33%);
  background-size: 800px 104px;
  height: 40px;
  width: calc(100% - 50px);
  position: relative;
}
@keyframes placeHolderShimmer{
  0%{
    background-position: -468px 0
  }
  100%{
    background-position: 468px 0
  }
}
</style>
